import { useState } from 'react'
import { AppBar, Toolbar, Typography, Box, Avatar, Menu, MenuItem, ListItemIcon } from '@mui/material'
import { AutoFixHigh, Logout, AccountCircle } from '@mui/icons-material'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { designSpecs } from '../../theme/designSpecs'

const DashboardNavbar = () => {
  const navigate = useNavigate()
  const { logout } = useAuth()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = async () => {
    const result = await logout()
    if (result.success) {
      handleClose()
      navigate('/')
    }
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'white',
        borderBottom: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Toolbar sx={{ height: 80, px: { xs: 2, sm: 3, lg: 4 } }}>
        {/* Logo and Title - Left aligned */}
        <Box
          component={RouterLink}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            textDecoration: 'none',
            transition: designSpecs.transitions.default,
            '&:hover .logo-icon': {
              transform: 'scale(1.05)',
            },
          }}
        >
          <Box sx={{ position: 'relative' }}>
            <Box
              className="logo-icon"
              sx={{
                width: 44,
                height: 44,
                background: designSpecs.gradients.primary,
                borderRadius: designSpecs.borderRadius.lg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: 3,
                transition: designSpecs.transitions.default,
              }}
            >
              <AutoFixHigh sx={{ color: 'white', fontSize: designSpecs.iconSizes.lg }} />
            </Box>
            <Box
              sx={{
                position: 'absolute',
                top: -4,
                right: -4,
                width: 12,
                height: 12,
                bgcolor: 'warning.main',
                borderRadius: '50%',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                '@keyframes pulse': {
                  '0%, 100%': {
                    opacity: 1,
                  },
                  '50%': {
                    opacity: 0.5,
                  },
                },
              }}
            />
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              background: designSpecs.gradients.primary,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              fontSize: designSpecs.typography.sizes['2xl'],
            }}
          >
            Mocksy
          </Typography>
        </Box>

        {/* Profile Icon on the right */}
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
          <Avatar
            onClick={handleClick}
            sx={{
              width: 36,
              height: 36,
              bgcolor: 'grey.200',
              border: '2px solid',
              borderColor: open ? 'primary.main' : 'grey.300',
              cursor: 'pointer',
              transition: designSpecs.transitions.default,
              '&:hover': {
                borderColor: 'primary.main',
                transform: 'scale(1.05)',
                bgcolor: 'grey.300',
              },
            }}
          >
            <AccountCircle sx={{ fontSize: 28, color: 'grey.600' }} />
          </Avatar>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              mt: 1,
            }}
            PaperProps={{
              sx: {
                borderRadius: designSpecs.borderRadius.lg,
                minWidth: 180,
                boxShadow: designSpecs.shadows.lg,
              },
            }}
          >
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default DashboardNavbar
